var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',[_c('font-awesome-icon',{attrs:{"icon":"shopping-cart"}})],1)],1),_c('f7-nav-title',[_vm._v("餐點明細")]),_c('f7-nav-right',[_c('f7-link',{on:{"click":function($event){return _vm.confirmDelete()}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }